module.exports = __webpack_public_path__ + "media/images/icon-link-s-15ee24cb4092f1fd5be123761b9a76fc.svg";